module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "fgua56zt",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
  /*  gitalk: {
    clientID: process.env.GATSBY_GITALK_CLIENT_ID,
    clientSecret: process.env.GATSBY_GITALK_CLIENT_SECRET,
    repo: process.env.GATSBY_GITALK_REPO,
    owner: process.env.GATSBY_GITALK_OWNER,
    admin: process.env.GATSBY_GITALK_ADMIN
      ? [...process.env.GATSBY_GITALK_ADMIN.split(";")]
      : [],
  }, */
};
